import React, { useState } from 'react';
import {
  MenuIcon,
  XIcon,
  BellIcon,
  LoginIcon
} from '@heroicons/react/solid';
import EngagementStats from './../EngagementStats/EngagementStats';
import styles from './CompactNavbar.module.css';
import { useAuth } from "../../utils/AuthContext/authcontext";
import { Link, useNavigate } from "react-router-dom";
import translations from "../../translations/translations";
import NotificationBadge from './../NotificationBadge/NotificationBadge';
import { useTranslation } from 'react-i18next';
import Button from '../ui/Button';


const CompactNavbar = ({lang = "en" ,shownow = true, modal = undefined, scrollY = 0, openContact, openLogin }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const blurStrength = Math.min(16 + scrollY * 0.05, 50); // Clamp for performance
  const { user, userData, logout, login, claims } = useAuth();
  const navigate = useNavigate(); 
  const t = translations[lang].navbar;
  const { t: i18nT } = useTranslation();

  const mlogout = () => {
  }

  if(modal == false){
		return (
		<>
		<nav className={styles["compact-navbar"]}
		style={{
			backdropFilter: `blur(${blurStrength}px)`,
			WebkitBackdropFilter: `blur(${blurStrength}px)`
		  }}>
		  <div className={styles["navbar-left"]}>
			<div>
			<div style={{"cursor": "pointer"}} onClick={() => navigate("/home")} className={styles.logo}>{t.title}</div>
			<h2 style={{"cursor": "pointer"}} onClick={() => navigate("/home")} className={styles.motto}>{i18nT('ui.motto')}</h2>
			</div>
		  </div>
		</nav>
		</>
	  );
  }
  else {
	  return (
		<>
		<nav className={styles["compact-navbar"]} 
		style={{
			backdropFilter: `blur(${blurStrength}px)`,
			WebkitBackdropFilter: `blur(${blurStrength}px)`
		  }}>
		  <div className={styles["navbar-left"]}>
			<div>
			<div style={{"cursor": "pointer"}} onClick={() => navigate("/home")} className={styles.logo}>{t.title}</div>
			<h2 style={{"cursor": "pointer"}} onClick={() => navigate("/home")} className={styles.motto}>{i18nT('ui.motto')}</h2>
			</div>
			<Button variant="primary" className={styles.hamburger} onClick={() => setMobileOpen(!mobileOpen)}>
			  {mobileOpen ? <XIcon className={styles.icon} /> : <MenuIcon className={styles.icon} />}
			</Button>
		  </div>

		  <ul className={`${styles["navbar-links"]} ${mobileOpen ? styles.open : ''}`}>
			<li><Link to="/home">{t.homePage}</Link></li>
			<li><Link to="/about">{t.aboutPage}</Link></li>
			<li><a style={{"cursor": "pointer"}} onClick={() => openContact()}>{i18nT('ui.contact')}</a></li>
			<li><Link to="/debates">{t.debateArenas}</Link></li>
			<li><Link to="/leaderboard">{t.leaderboard}</Link></li>
			<li><Link to="/profile">{t.profile}</Link></li>
			{/*<li><Link to="/training">{t.trainingMode}</Link></li>*/}
			{claims?.role == 'admin' ? <li><Link to="/admin/siteinfo">{t.adminPage}</Link></li> : <></>}
			<li className={`${styles["navbar-nolinks"]}`}>
			  <Link  to="/notifications"><NotificationBadge className={styles.icon}/></Link>
			</li>
		  </ul>

		  <div className={styles["navbar-right"]}>
			<Button variant="primary" className={styles["login-btn"]} onClick={() => { openLogin != null ? openLogin(user) : mlogout()}}>
			  <LoginIcon className={styles.icon} />
			  {user != null ? "Logout" : "Login"}
			</Button>
		  </div>

		</nav>
		{shownow == true ? <EngagementStats shownow={shownow} />: <></>}
		</>
	  );
  }
};

export default CompactNavbar;
